<script lang="ts">
  import type { NewsFromManyResponse } from '@entities/news';

  export let publicationDate: string | null;
  export let readTime: number | null;
  export let author: NewsFromManyResponse['data'][number]['author'];
  export let classes = '';
</script>

<div class="{classes} dark:text-dark-800 text-default-500">
  {#if publicationDate}
    {#if author}
      <span aria-hidden="true" class="hidden md:block">•</span>
    {/if}

    <span>{publicationDate}</span>
  {/if}

  {#if readTime}
    <div class="flex shrink-0 gap-2 md:gap-3">
      {#if publicationDate || author}
        <span aria-hidden="true">•</span>
      {/if}

      <span class="flex shrink-0">{readTime} min read</span>
    </div>
  {/if}
</div>
